interface InvestorTagProps {
  children: React.ReactNode
}

export function InvestorTag({ children }: InvestorTagProps) {
  return (
    <span className="rounded border border-border/50 bg-muted/60 px-2 py-0.5 text-xs text-muted-foreground">
      {children}
    </span>
  )
}
